import { render, staticRenderFns } from "./TipoCambioPage.vue?vue&type=template&id=4a22bf35"
import script from "./TipoCambioPage.js?vue&type=script&lang=js&external"
export * from "./TipoCambioPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports